import React from "react";
import { View, Text } from "@components";
import { localize } from "redux-i18n";

class EmployeeTypeExposure extends React.Component {
  get typesInfo() {
    return {
      EMPLOYEE: {
        explanationText: "EMPLOYEE_TYPE_EXPLANATION",
        riskColor: "bg-mint",
        riskLevel: "LOW",
      },
      MANAGER: {
        explanationText: "MANAGER_TYPE_EXPLANATION",
        riskColor: "bg-mint",
        riskLevel: "LOW",
      },
      CLIENT_SUPPLIER: {
        explanationText: "SUPPLIER_TYPE_EXPLANATION",
        riskColor: "bg-coffee",
        riskLevel: "MEDIUM",
      },
      CLIENT_DATA_TRANSFER: {
        explanationText: "DATA_TRANSFER_TYPE_EXPLANATION",
        riskColor: "bg-rose",
        riskLevel: "HIGH",
      },
      CLIENT_ADMIN: {
        explanationText: "CLIENT_ADMIN_TYPE_EXPLANATION",
        riskColor: "bg-rose",
        riskLevel: "HIGH",
      },
      ADVANCED_USER: {
        explanationText: "ADVANCED_USER_TYPE_EXPLANATION",
        riskColor: "bg-coffee",
        riskLevel: "MEDIUM",
      },
      CLIENT_TREND_VIEWER: {
        explanationText: "TREND_VIEWER_TYPE_EXPLANATION",
        riskColor: "bg-mint",
        riskLevel: "LOW",
      },
      FULL_HR_ACCESS: {
        explanationText: "FULL_ACCESS_TYPE_EXPLANATION",
        riskColor: "bg-rose",
        riskLevel: "HIGH",
      },
      DEVELOPER: {
        explanationText: "DEVELOPER_TYPE_EXPLANATION",
        riskColor: "bg-rose",
        riskLevel: "HIGH",
      },
    };
  }

  get shouldShowExposure() {
    const userTypesWithExposure = [
      "EMPLOYEE",
      "MANAGER",
      "CLIENT_SUPPLIER",
      "CLIENT_DATA_TRANSFER",
      "CLIENT_ADMIN",
      "ADVANCED_USER",
      "CLIENT_TREND_VIEWER",
      "FULL_HR_ACCESS",
      "DEVELOPER",
    ];

    return userTypesWithExposure.includes(this.props.currentType);
  }

  get currentTypeInfo() {
    return this.shouldShowExposure && this.typesInfo[this.props.currentType];
  }

  render() {
    if (!this.shouldShowExposure) {
      return null;
    }

    return (
      <View flex={1} width="100%" position="absolute" top="88px">
        <View margin="1rem 0 0 0" gap={3} direction="row" alingItems="center">
          <Text size={1.125} weight="bold">
            {this.props.t("DATA_EXPOSURE_INDEX")}
          </Text>
          <View
            justifyContent="center"
            className={`status-badge pill ${this.currentTypeInfo.riskColor}`}
          >
            <Text size={1.125} weight="bold">
              {this.props.t(this.currentTypeInfo.riskLevel)}
            </Text>
          </View>
        </View>
        <View
          margin="0.75rem 0 0 0"
          padding="0.5rem"
          className={`borders-solid-color-grey ${this.currentTypeInfo.riskColor}`}
        >
          <Text size={0.75}>{this.props.t(this.currentTypeInfo.explanationText)}</Text>
        </View>
      </View>
    );
  }
}

export default localize()(EmployeeTypeExposure);
